export const LOGIN_REQUEST = 'auth/LOGIN_REQUEST'
export const LOGIN_SUCCESS = 'auth/LOGIN_SUCCESS'
export const LOGIN_ERROR = 'auth/LOGIN_ERROR'
export const LOGOUT_SUCCESS = 'auth/LOGOUT_SUCCESS'
export const GET_PROFILE = 'auth/GET_PROFILE'
export const REDIRECT = 'auth/REDIRECT'
